<template>
    <Widget title="NSFW" :area="this.$props.area" :scrollable="true">
        <template v-if="hasData">
            <el-popover slot="action" placement="bottom" width="200" trigger="click">
                <div>
                    <div>
                        <el-radio v-model="show" label="comments">Comments</el-radio>
                        <el-radio v-model="show" label="karma">Karma</el-radio>
                    </div>
                    <el-input placeholder="Subreddit Filter" v-model="nameFilter"/>
                </div>
                <button class="head-button" slot="reference"><i class="el-icon-search"/></button>
            </el-popover>
            <NameValue v-for="sub in data"
                       :key="sub.subreddit"
                       :name="sub.subreddit"
                       :type="show"
                       :value="sub.value"
                       :callback="()=>open(sub)"/>
        </template>
    </Widget>
</template>

<script>
    import Widget from "../Widget";
    import {mapGetters} from "vuex";
    import NameValue from "../NameValue";

    export default {
        components: {NameValue, Widget},
        props: {area: String, dialog: Function},
        data() {
            return {nameFilter: '', show: 'comments'}
        },
        computed: {
            ...mapGetters(['user', 'allPosts', 'comments', 'submissions']),
            nsfw() {
                return this.allPosts.filter(d => d.data.over_18)
            },
            hasData() {
                return this.nsfw.length > 0
            },
            data() {
                let subs = this.nsfw.filter(d => d.data.over_18).reduce((a, c) => {
                    if (a[c.data.subreddit]) {
                        a[c.data.subreddit].push(c)
                    } else {
                        a[c.data.subreddit] = [c]
                    }
                    return a;
                }, {})

                return Object.entries(subs).map(([k, v]) => {
                    let nv = v.length;
                    if(this.show==='karma')
                        nv = v.reduce((a, c) => a + c.data.score, 0);

                    return {subreddit: k, posts: v, value: nv}
                }).sort((a, b) => b.value - a.value);
            }
        },
        methods: {
            open(subreddit) {
                console.log(subreddit)
                this.dialog('NSFW '+subreddit.subreddit + ' Posts', subreddit.posts)
            }
        }
    }
</script>

<style scoped>

</style>
